<awair-device-marker-icon class="__icon"
                          [color]="color"
                          awairDraggable
                          [zone]="'editor-device'"
                          [data]="{deviceUuid: deviceUuid, deviceName: name}"
                          [imgSrc]="'assets/images/floor-plan/ic_marker-online.svg'">
</awair-device-marker-icon>
<awair-device-marker-tooltip class="__tooltip"
                             [canClose]="true"
                             (close)="onRemove()">
  {{name}}
</awair-device-marker-tooltip>
